module.exports = __webpack_public_path__ + "img/12.f2daa014.png";